import home from "@project/templates/home/home";
import packCyber from "@project/templates/pack-cyber/packCyber";
import modulesOutils from "@project/templates/modules-outils/modulesOutils";
import prestationExpertes from "@project/templates/prestation/prestation";
export default [home, packCyber, modulesOutils, prestationExpertes];
